// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"e2e343c6","455":"e0a20ffa","488":"8a8aefc9","977":"c1635f1a"}[chunkId] + ".chunk.js";
};